import React, { useState, useRef, useEffect } from 'react';
import './Accordion.css'

function Accordion() {
    const [openIndex, setOpenIndex] = useState(null);
    const contentRefs = useRef([]);

    useEffect(() => {
        contentRefs.current.forEach((ref, index) => {
            if (ref) {
                ref.style.maxHeight = index === openIndex ? `${ref.scrollHeight}px` : '0';
            }
        });
    }, [openIndex]);

    const handleToggle = (index) => {
        setOpenIndex(index === openIndex ? null : index);
    };

    return (

        <div className='rounded-lg my-[30px]'>
            {accordionData.map((item, index) => (
                <div key={index} className="w-full bg-[#3498DB]  rounded-[10px]">
                    <div
                        className="w-full  text-dark flex justify-between items-center text-white px-[20px] py-[12px] cursor-pointer rounded-[10px]"
                        onClick={() => handleToggle(index)}>
                        <span ><div className='md:text-[18px] text-[12px] font-semibold'>{item.title}</div></span>
                        <div className='flex items-center justify-center '>
                            <span className='text-[26px]'>
                                {openIndex === index ? (
                                    // <img   alt="add" className='w-[15.38px]' />
                                    <div>-</div>
                                ) : (
                                    <div>+</div>
                                )}
                            </span>
                        </div>
                    </div>
                    <div
                        ref={(el) => contentRefs.current[index] = el}
                        className={`accordion-content text-white overflow-hidden ${openIndex === index ? 'accordion-content-open' : 'accordion-content-closed'}`}>
                        <div className="px-4 md:text-[18px] text-[11px] font-normal">
                           
                            <ul className="list-disc mt-2">
                                <li> 40 mins to Gachibowli</li>
                                <li>25 mins to Neopolis</li>
                                <li>20 mins to ORRs</li>
                            </ul>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

const accordionData = [
    {
        title: "Key Connectivity Near MR.HOUSING INDIA",
    },


];

export default Accordion;
